import type { BoxProps } from '@mui/material/Box';

import { m } from 'framer-motion';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { varFade, MotionViewport } from 'src/components/animate';

export function ThankYouPayment({ sx, ...other }: BoxProps) {
  return (
    <Box
      component="section"
      sx={[{ overflow: 'hidden' }, ...(Array.isArray(sx) ? sx : [sx])]}
      {...other}
    >
      <Container component={MotionViewport} sx={{ textAlign: 'center', pb: { xs: 10, md: 15 } }}>
        <img
          style={{ width: '50%', maxWidth: '300px', marginBottom: '0px' }}
          src="./assets/bridge.png"
        />
        <m.div variants={varFade('inDown')} />

        <m.div variants={varFade('inUp')}>
          <Typography variant="h2" sx={{ mb: 3 }}>
            Din betaling er modtaget!
          </Typography>
        </m.div>

        <m.div variants={varFade('inUp')}>
          <Typography sx={{ mx: 'auto', maxWidth: 640, color: 'text.secondary' }}>
            Hvis du har lyst, vil vi sætte stor pris på, at du deler din oplevelse med os på Google.
            <br />
          </Typography>
          <br />
          <a
            href="https://g.page/r/CeTB3dTr6KF2EAE/review"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tryk her og del din mening
          </a>
          <br />
          <br />
          <Typography sx={{ mx: 'auto', maxWidth: 640, color: 'text.secondary' }}>
            Vi håber at kunne hjælpe dig igen i fremtiden og ønsker dig alt det bedste.
            <br />
            <br />
          </Typography>
        </m.div>
      </Container>
    </Box>
  );
}
